<template>
  <section class="userAwsAccount">
    <v-container
      v-if="newAwsAccount.registrationStep === 'listing' || newAwsAccount.registrationStep === 'validation'"
      mt-3
      fluid
      class="header">
      <v-layout row >
        <v-flex
          xs12
          sm5
          md4>
          <v-card>
            <div class="opportunity-lookup">
              <h4>Look up Opportunity Registration</h4>
              <v-form @submit.prevent="onSearchOpportunityId">
                <v-text-field
                  v-model.trim="searchId"
                  :success="!newAwsAccount.searchError"
                  :error="newAwsAccount.searchError"
                  :messages="newAwsAccount.searchMessage"
                  :loading="newAwsAccount.searching"
                  label="Enter Opportunity ID"
                  solo
                  outlined
                  append-icon="search"
                  dark
                  @click:append="onSearchOpportunityId"
                />
              </v-form>
            </div>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          sm7
          md8>
          <v-card
            v-if="awsAccountListing.selectedWorkload.length > 0 ? true: false"
            class="opportunity-details ml-4">
            <!-- <v-card class="opportunity-details ml-4" > -->
            <v-layout
              row
              wrap>
              <h4>Record Details</h4>
              <v-flex md12>
                <v-text-field
                  v-model="newAwsAccount.opportunityName"
                  label="Opportunity Name"
                  hide-details
                  readonly
                />
              </v-flex>
              <v-flex md12>
                <v-text-field
                  v-model="newAwsAccount.workloadTitle"
                  label="Project/ Workload Title"
                  hide-details
                  readonly
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="newAwsAccount.submittedDate"
                  label="Submitted Date"
                  hide-details
                  readonly
                  class="mr-2"
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="newAwsAccount.oppregStatus"
                  label="Oppreg Status"
                  hide-details
                  readonly
                  class="ml-2"
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="newAwsAccount.workloadType"
                  label="Workload Type"
                  hide-details
                  readonly
                  class="ml-2"
                />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <formUserAwsAcctList v-if="newAwsAccount.registrationStep === 'listing'" />

    <div
      v-if="(awsAccountListing.selectedWorkload.length > 0 ? true: false ) && newAwsAccount.registrationStep == 'listing' && newAwsAccount.noDiscount === false"
      style="border-top: 2px solid lightgray; margin: 25px;padding: 25px 0;"
      class="requestor-details">
      <v-container
        fluid
        style="padding: 0">
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            sm12
            md12
            xl12>
            <v-progress-linear
              v-slot:progress
              v-if="loadingRequestorContactInfo === true"
              color="orange"
              indeterminate/>
            <section v-if="!loadingRequestorContactInfo">
              <v-container
                fluid
                style="padding:0;margin:25px 0">
                <div style="background-color:#000;color: #fff;padding:0 15px">
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <h4>Requestor Contact Information</h4>
                    </v-flex>
                  </v-layout>
                </div>
                <div style="padding:15px 15px; border:1px solid #000">
                    <v-checkbox @change="onSameAsLoggedInUserChecked">
                      <template v-slot:label>
                        Check this box if same as logged in user
                      </template>
                    </v-checkbox>
                  <v-layout
                    row
                    wrap>
                   <v-flex
                      xs12
                      sm12
                      md2
                      xl2>
                      <v-select
                        v-model="newAwsAccount.accountRecord.contact.Contact_Title"
                        :items="titles"
                        placeholder="Title"
                        label="Title"
                        class="mr-2"
                        attach
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md5
                      xl5>
                      <v-text-field
                        v-model="newAwsAccount.accountRecord.contact.Contact_First_Name"
                        placeholder="Firstname"
                        label="First Name"
                        class="mr-2"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md5
                      xl5>
                      <v-text-field
                        v-model="newAwsAccount.accountRecord.contact.Contact_Last_Name"
                        placeholder="Last Name"
                        label="Last Name"
                        class="mr-2"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md6
                      xl6>
                      <v-text-field
                        v-model="newAwsAccount.accountRecord.contact.Contact_Phone"
                        placeholder="Phone"
                        label="Phone"
                        class="mr-2 "
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md6
                      xl6>
                      <v-text-field
                        v-model="newAwsAccount.accountRecord.contact.Contact_Email"
                        label="Email"
                        placeholder="Email"

                      />
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <v-layout
                        column
                        align-end>
                        <v-btn
                          :loading="newAwsAccount.savingContact"
                          :disabled="loadingRequestorContactInfo"
                          color="warning"
                          @click="submitContact" >Save and Continue</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>
              </v-container>
            </section>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <formUserAwsAcctValidation
      v-if="newAwsAccount.registrationStep === 'validation'"
      :type="'New'"
      @previous="goBackToListing"
      @cancel="onAwsValidationCancel"
      @save-for-later="onAwsValidationSaveForLater"
      @submit="onAwsValidationSubmit" />

    <formReqAwsQuestionnaire
      v-if="newAwsAccount.registrationStep === 'onboarding'"
      :type="'New'"
      @previous="goBackToValidation"
      @cancel="onQuestionnaireCancel"
      @continue="onOnboardingSubmit" />
    <formReqAwsContact 
      v-if="newAwsAccount.registrationStep === 'contact'" 
      :type="'New'"
      @go-to-onboarding="goBackToQuestionnaire"
      @save="onContactsSave"
      @reset="onReset"/>

    <!-- ERROR MESSAGE -->
    <v-dialog
      v-model="errorDialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-text>
          <div v-if="errorContinue === false">
            <h3 style="font-weight:600!important">Oops! Contact Information cannot be submitted.</h3>
            <p>This opportunity has not been registered with AWS Opportunity Registration. This step is required prior to creating an AWS account. Please go to: <router-link
              :to="'/request-oppreg/external-oppreg'"
              style="font-weight:500;display:inline !important"
              tag="div"
              class="view-link"
              title="View" > Register New External Client Opportunity
            </router-link> and register the opportunity. </p>
            <p>Questions re: Account Onboarding, contact: aws-account-onboarding@cloud.dxc.com. </p>
            <p>Questions re: Opportunity Registration, contact: aws-oppreg@cloud.dxc.com.</p>
          </div>
          <p v-if="errorContinue === true">Thank you for submitting the request to OppReg. Account creation will proceed once the OppReg is approved</p>

        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"/>
          <v-btn
            color="orange darken-1"
            text
            @click="errorDialog = false">Close</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- GET EMAIL MODAL  -->
    <v-dialog
      v-model="searchEmailDialog"
      persistent
      max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          <div v-if="findEmail === true">
            <div style="background-color:#000;border:1px solid lightgray;padding:15px 15px" >
              <v-form>
                <v-layout
                  row
                  wrap
                  align-center
                  justify-center>
                  <v-flex
                    xs12
                    sm12
                    md4
                    xl4>
                    <v-text-field
                      v-model.trim="requestorContactInfo.emailAddress"
                      solo
                      clearable
                      label="Search email..."
                      hide-details
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    md2
                    xl2>
                    <v-btn
                      color="warning"
                      class="search-opp-btn"
                      @click="getEmail()">Search</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </div>
            <v-progress-linear
              v-slot:progress
              v-if="requestorContactInfo.loadingEmailData === true"
              color="orange"
              indeterminate/>
            <v-data-table
              v-if="emailData === true"
              :headers="requestorContactInfo.emailListHeaders"
              :items="requestorContactInfo.emails"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>
                  <div
                    style="cursor:pointer; color:#ff9900;font-weight:400"
                    @click= "selectedContact(props.item.Id)"
                  >
                    Select
                  </div>
                </td>
                <td>{{ props.item.Contact_First_Name }}</td>
                <td>{{ props.item.Contact_Last_Name }}</td>
                <td>{{ props.item.Contact_First_Name }}</td>

              </template>
            </v-data-table>
          </div>
          <div v-if="createContact == true">
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md12><label>Title:</label></v-flex>
              <v-flex>
                <v-text-field
                  v-model="requestorContactInfo.newContact.Contact_Title"
                  placeholder="Title"
                  solo
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12><label>First Name:</label></v-flex>
              <v-flex>
                <v-text-field
                  v-model="requestorContactInfo.newContact.Contact_First_Name"
                  placeholder="First Name"
                  solo
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12><label>Last Name:</label></v-flex>
              <v-flex>
                <v-text-field
                  v-model="requestorContactInfo.newContact.Contact_Last_Name"
                  placeholder="Last Name"
                  solo
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12><label>Phone:</label></v-flex>
              <v-flex>
                <v-text-field
                  v-model="requestorContactInfo.newContact.Contact_Phone"
                  placeholder="Phone"
                  solo
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12><label>Email Address:</label></v-flex>
              <v-flex>
                <v-text-field
                  v-model="requestorContactInfo.newContact.Contact_Email"
                  placeholder="Email Address"
                  solo
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
                xl12>
                <v-btn
                  color="orange darken-1"
                  text
                  @click="insert()">Add Contact</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout
            align-end
            justify-end>
            <div class="flex-grow-1"/>
            <v-btn
              v-if="createContact===true"
              color="orange darken-1"
              text
              @click="findEmail=true;createContact=false;modalTitle='Find Contact by Email'">Find Contact</v-btn>
            <!-- <v-btn color="orange darken-1" text v-if="findEmail ===true" @click="addNewContact()">Create New Contact</v-btn> -->
            <v-btn
              color="orange darken-1"
              @click="close()">Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      // searchId: null,
      errorDialog: false,
      errorContinue: false,
      // sfdcId: "",
      search: '',
      modalTitle: '',
      selContact: null,
      searchEmailDialog: false,

      findEmail: false,
      emailData: false,
      createContact: false,
      rowsPerPageItems: [10, 20, 30, 40],
      selectedAccount: false,
      selAcct: '',
      acctSelected: [],
      titles: ['Mr.', 'Ms.', 'Mrs.'],
      sameAsLoggedInUser: false,
      pagination: {
        rowsPerPage: 10
      },
      customerListHeaders: [
        {
          sortable: true,
          text: 'Opportunity ID',
          value: ''
        },
        {
          sortable: true,
          text: 'Workload Title',
          value: 'Acct_name'
        },
        {
          sortable: true,
          text: 'OppReg Req Date',
          value: 'Acct_DL'
        },
        {
          sortable: true,
          text: 'Workload Status',
          value: 'Acct_ID'
        }
      ]
    }
  },
  computed: {
    ...mapState('user/requestAws', [
      'newAwsAccount',
      'awsAccountListing',
      'requestorContactInfo',
      'loadingRequestorContactInfo',
      'awsAccountValidation'
    ]),

    searchId: {
      get () {
        return this.newAwsAccount.sfdcId
      },
      set (val) {
        this.setSearchSfdcId(val)
      }
    }
  },
  beforeDestroy () {
  },
  mounted () {
    this.$store.commit('user/requestAws/clearAwsAccountListing')
    this.$store.commit('user/requestAws/clearNewAccount')
    this.$store.commit('user/requestAws/clearValidation')
    this.$store.commit('user/requestAws/clearOnboardingQuestionnaire')
    this.$store.commit('user/requestAws/clearAwsAccountContacts')
     this.$store.dispatch('user/requestAws/getAllCustomers')
  },
  methods: {
    ...mapMutations('user/requestAws', ['setSearchSfdcId', 'setNewSelectedContact']),
    ...mapActions({
      getWorkloadByOppId: 'user/requestAws/getOppregProject',
      getWorkloadContactInfo: 'user/requestAws/getContactInfo',
      checkEmail: 'user/requestAws/checkEmailAvailability',
      addContact: 'user/requestAws/createContact',
      updateWorkloadContactInfo: 'user/requestAws/updateContactInfo'
    }),
    searchEmail () {
      this.searchEmailDialog = true
      this.findEmail = true
      this.modalTitle = 'Find Contact By Email'
    },
    getEmail () {
      this.checkEmail(this.requestorContactInfo.emailAddress)
      this.emailData = true
    },
    selectedContact (Id) {
      var result = this.requestorContactInfo.emails.filter(obj => {
        return obj.Id === Id
      })
      this.setNewSelectedContact(result[0])
      this.searchEmailDialog = false
      let emails = this.emails
      emails.pop()
      this.emailData = false
      this.createContact = false
    },
    submitContact () {
      let approvedStatus = ['AWS Reg Accepted', 'Approved - Tier 1 23% - PPA','Approved - Tier 1 23% - PPA SaaS','Approved - Tier 3 12%', 'Approved - Tier 2 - Custom EDP', 'LEGACY - Approved - Tier 1 23% - PPA', 'LEGACY - Approved - Tier 1 23% - PPA SaaS', 'LEGACY - Approved - Tier 3 12%', 'LEGACY - Approved - Tier 2 - Custom EDP']
      let pendingStatus = ['Submitted by User', 'Submitted to AWS']

      if (approvedStatus.includes(this.newAwsAccount.oppregStatus)) {
        this.updateWorkloadContactInfo(this.newAwsAccount.accountRecord.contact)
      } else if(pendingStatus.includes(this.newAwsAccount.oppregStatus)){
        this.errorDialog = true
        this.errorContinue = true
          this.$store.commit('user/requestAws/setNewAcctOnboardingStatus','Pending OppReg')
          this.updateWorkloadContactInfo(this.newAwsAccount.accountRecord.contact)
      } else {
        this.errorDialog = true
        this.errorContinue = false
      }
    },
    addNewContact () {
      this.findEmail = false
      this.createContact = true
      this.modalTitle = 'Create New Contact'
    },
    insert () {
      this.addContact(this.workload)
    },
    close () {
      let emails = this.requestorContactInfo.emails
      emails.pop()
      this.emailData = false
      this.createContact = false
      this.requestorContactInfo.emailAddress = ''
      this.searchEmailDialog = false
    },
    goBackToListing () {
      console.log('-- tesst go back to listing --')
      this.$store.commit('user/requestAws/setRegistrationStep', 'listing')
    },
    goBackToValidation () {
      console.log('-- tessst GO BACK to validation ----')
      this.$store.commit('user/requestAws/setRegistrationStep', 'validation')
    },
    goBackToQuestionnaire () {
      console.log('-- Go Back to Questionnaire --')
      this.$store.commit('user/requestAws/setRegistrationStep', 'onboarding')
    },
    onSearchOpportunityId () {
      this.$store.commit('user/requestAws/clearAwsAccountListing')
      this.$store.commit('user/requestAws/clearNewAccount')
      this.$store.dispatch('user/requestAws/searchOpportunityId', this.searchId)
    },
    onSameAsLoggedInUserChecked(flag){
      if(flag){
        let contactUser = this.$store.state.currentUser
        let contactObj = {
          Contact_Title:'',
          Contact_First_Name: contactUser.given_name, 
          Contact_Last_Name: contactUser.family_name, 
          Contact_Phone: contactUser.phone, 
          Contact_Email: contactUser.email
        }
        this.$store.commit('user/requestAws/setRequestorContactInfo', contactObj )
      }
    },
    onAwsValidationCancel () {
      // event for cancel aws validation button
      this.$store.commit('user/requestAws/clearValidation')
      this.$store.commit('user/requestAws/setRegistrationStep', 'listing')
    },
    onAwsValidationSaveForLater (data) {
      // event for save for later aws validation button
      // this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount',
        this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding
      )
    },
    onAwsValidationSubmit (data) {
      console.log('--------333-----------')
      console.log(data)
      console.log('---------------------')
      // event for submit aws validation button
      // this.$store.commit('user/requestAws/updateOnboarding', onboarding)
      // this.$store.dispatch('user/requestAws/insertWbsAndIwo', data)
      if (!data.isCustRegion){
        this.$store.dispatch('user/requestAws/addCustomer', {Customer_Alias: data.custAlias, Customer_Name: data.custName, Customer_Region: data.custRegion})
      }

      console.log('------- onAwsValidationSubmit ---------')
      console.log('isCustRegion: ', data.isCustRegion)
      console.log('custRegionId: ', data.custRegionId)
      console.log('-----------------------------------------')
      if(data.isCustRegion && data.custRegionId !== ''){
        console.log('UPDATE CUSTOMER!!!')
        let custObj = {
          Customer_Id: data.custRegionId, 
          Customer_Alias: data.custAlias
        }
        this.$store.dispatch('user/requestAws/updateCustomer', { Customer_Id: data.custRegionId, Customer_Alias: data.custAlias })
      }
      
      this.$store.commit('user/requestAws/setRegistrationStep', 'onboarding')
    },
    onOnboardingSubmit (onboarding) {
      this.$store.commit('user/requestAws/updateOnboarding', onboarding)
      this.$store.commit('user/requestAws/setRegistrationStep', 'contact')
    },
    onContactsSave (contacts) {
      this.$store.commit('user/requestAws/updateOnboardingContacts', contacts)
      // here we dispatch the onboarding-header record creation
      this.$store.dispatch('user/requestAws/createOnboardingAccount',{ 
        record: this.$store.state['user/requestAws'].newAwsAccount.accountRecord.onboarding,
        oppregStatus: this.$store.state['user/requestAws'].newAwsAccount.oppregStatus,
        isSaas: this.$store.state['user/requestAws'].awsAccountOnboarding.fields.SaaS,
        custName: this.$store.state['user/requestAws'].awsAccountOnboarding.fields.Tmp_Cust_Name,
        custRegion:this.$store.state['user/requestAws'].awsAccountOnboarding.fields.Cust_Region,
        mpid: this.$store.state['user/requestAws'].awsAccountOnboarding.fields.MP_ID,
        // mpid:'828823959955',
        type: 'new'
        }
      )
    },
    onReset () {
      this.$store.commit('user/requestAws/clearAwsAccountListing')
      this.$store.commit('user/requestAws/clearNewAccount')
      this.$store.commit('user/requestAws/clearValidation')
      this.$store.commit('user/requestAws/clearOnboardingQuestionnaire')
      this.$store.commit('user/requestAws/clearAwsAccountContacts')
    }
  }
}
</script>
<style lang="scss" >
.userAwsAccount {
  // padding: 15px 0;
  background-color: #fff;
  height:100%;

  .header {
    .opportunity-lookup {
      padding: 10px;
      background: #000;
      color: #fff;
    }

    .opportunity-details {
      background: #000;
      color: #fff;
      padding: 10px 10px 20px 10px;

      [type=text] {
        color: #fff;
      }
    }
    .search-opp {
      background-color: #000;
      margin: 15px 15px;
      padding: 25px 15px;
      .v-messages {
        min-height: 0 !important;
      }
      .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 0;
      }
    }

    .v-text-field__slot .v-label {
      color: #fff !important;
    }
  }
}

.view-link {
  cursor: pointer;
  color: #ff9900 !important;
}
table.v-table thead th {
  font-weight: 600;
}

section.userAwsAccount {
  .search-opp {
    background-color:#000;
    margin:15px 15px;
    padding:25px 15px
  }
  table.v-table thead th {
    font-weight: 600;
  }

  .v-datatable thead th {
    // background-color: #000;
    // color: #fff;
    font-weight: 400;

    span {
      // color: #fff !important;
      font-size: 14px !important;
      font-weight: 500 !important;
    }
  }
}
</style>
